<fo-toolbar>
  <ng-container leftElements>
    <fo-breadcrumb></fo-breadcrumb>
  </ng-container>
  <ng-container rightElements>
    <fo-kebab-menu [items]="kebabItems"> </fo-kebab-menu>
  </ng-container>
</fo-toolbar>
<crm-container [maxSize]="'xl'" [noPaddingTop]="true">
  @if (
    ticketSupportMultimachineFormService.form$ | async;
    as ticketSupportMultimachineForm
  ) {
    <form
      #ngForm="ngForm"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="main-form remove-form-margin-and-padding"
    >
      <div class="row mx-0 overflow-auto">
        <!-- Left -->
        <div class="left-col col-md-8" #mainTabGroup>
          <mat-tab-group
            (selectedTabChange)="onTabClick($event)"
            [(selectedIndex)]="selected"
            class="remove-mat-tab-group-margins main-navigation-tabs"
            animationDuration="0ms"
          >
            <!-- Info table  -->
            <mat-tab [attr.data-testid]="'ticket-support-info-tab'">
              <ng-template mat-tab-label
                >{{ 'forms:info' | i18nextCap }}
              </ng-template>
              <div class="tab-content">
                <form class="info-tab-form" (ngSubmit)="updateTicket({})">
                  <crm-form-template
                    class="hidden-md hidden-lg"
                    [formGroup]="detailsFormGroup"
                    [formFields]="formDetailsFields"
                  ></crm-form-template>
                  <fo-work-order-scheduling-issues
                    class="hidden-md hidden-lg"
                    [overlaps]="overlaps"
                  >
                  </fo-work-order-scheduling-issues>
                  <crm-form-template
                    [formGroup]="infoTabFormGroup"
                    [formFields]="infoTabFormFields"
                  ></crm-form-template>
                  <div class="field-with-plus">
                    <mat-form-field
                      appearance="outline"
                      class="fullwidth-field"
                    >
                      <mat-label>{{ 'equipments' | i18nextCap }}</mat-label>
                      <ng-template
                        #equipmentsCustomChoiceOptionTemplate
                        let-choice
                      >
                        <div style="padding-top: 3px; padding-bottom: 3px">
                          <span style="display: block; width: 100%">{{
                            choice.name
                          }}</span>
                          <span
                            style="
                              display: block;
                              width: 100%;
                              font-size: 12px;
                              line-height: 10px;
                            "
                            >{{
                              'ACTION_EQUIPMENTS_SELECTOR_SERIAL_NUMBER_LABEL'
                                | i18nextCap
                            }}: {{ choice.serialNumber }}</span
                          >
                          @if (choice.ownership) {
                            <span
                              style="
                                display: block;
                                width: 100%;
                                margin-top: 4px;
                                font-size: 12px;
                                line-height: 10px;
                                font-style: italic;
                                color: #6e6b7b;
                              "
                              >{{
                                (choice.ownership === 'UNASSIGNED'
                                  ? 'EQUIPMENT_NOT_ASSIGNED'
                                  : 'EQUIPMENT_ALREADY_ASSIGNED_TO_COMPANY'
                                ) | i18nextCap
                              }}</span
                            >
                          }
                        </div>
                      </ng-template>
                      <fo-autocompleting-select-multiple
                        [formControl]="infoTabFormGroup.controls.equipments"
                        [choices]="equipmentOptions$"
                        [choiceOptionTemplate]="
                          equipmentsCustomChoiceOptionTemplate
                        "
                        [activeOptionLabel]="
                          equipmentsDisplaySelectedOptionLabel
                        "
                      >
                      </fo-autocompleting-select-multiple>
                      <mat-icon
                        matSuffix
                        class="tooltip-icon"
                        [matTooltip]="equipmentsTooltipKey | i18nextCap"
                        matTooltipPosition="left"
                        >info_outline</mat-icon
                      >
                    </mat-form-field>
                    @if (
                      canCreateEquipment &&
                      infoTabFormGroup.controls.equipments.enabled
                    ) {
                      <fo-plus-button
                        (click)="onCreateEquipment()"
                      ></fo-plus-button>
                    }
                  </div>
                  @if (entity) {
                    <fo-file-upload
                      [attachments]="attachmentSet.displayedAttachments"
                      [acceptedFileTypes]="acceptedFileTypes"
                      [disabled]="preview || !canManageAttachments"
                      (newAttachmentsChange)="onAttachmentsChange($event)"
                    ></fo-file-upload>
                  }
                  <button
                    type="submit"
                    mat-flat-button
                    color="primary"
                    class="button-fix"
                    [disabled]="isSubmitInfoTabDisabled$ | async"
                  >
                    {{ 'forms:save' | i18nextCap }}
                  </button>
                </form>
              </div>
            </mat-tab>
            <!-- Actions table  -->
            <ng-container *hasPermission="{ permissions: requestPermissions }">
              @if (entity) {
                <mat-tab [attr.data-testid]="'ticket-support-intervention-tab'">
                  <ng-template mat-tab-label
                    >{{ 'translation:actions' | i18nextCap }}
                  </ng-template>
                  @if (ticket$ | async) {
                    <div class="tab-content">
                      <crm-work-order-actions
                        [isDetailPage]="preview"
                        [ticket$]="ticket$"
                        [ticketId]="ticketId"
                        (openRequestTab)="openRequestTab()"
                        [openedIndex]="accordionOpenedIndex"
                        [equipments]="equipments$"
                      ></crm-work-order-actions>
                    </div>
                  }
                </mat-tab>
              }
            </ng-container>
            <!-- Requests table  -->
            <ng-container *hasPermission="{ permissions: requestPermissions }">
              @if (entity) {
                <mat-tab [attr.data-testid]="'ticket-support-request-tab'">
                  <ng-template mat-tab-label>
                    {{ 'forms:partRequests' | i18nextCap }}
                  </ng-template>
                  <div class="tab-content">
                    <crm-ticket-support-request-parts
                      [isDetailPage]="preview"
                      [ticket]="$any(ticket)"
                      [formGroup]="
                        $any(ticketSupportMultimachineForm.controls.ticketParts)
                      "
                      [users$]="technician$"
                      [usersParts$]="usersParts$"
                      [requests]="entity.requests"
                      (openEvent)="openTicketRequest($any($event))"
                      (removePartEvent)="removePart($event)"
                      (addPartEvent)="addPart($event)"
                    ></crm-ticket-support-request-parts>
                  </div>
                </mat-tab>
              }
            </ng-container>
            <!-- Reports table  -->
            <ng-container *hasPermission="{ permissions: reportPermissions }">
              @if (entity) {
                <mat-tab [attr.data-testid]="'ticket-support-reports-tab'">
                  <ng-template mat-tab-label
                    >{{ 'forms:reports' | i18nextCap }}
                  </ng-template>
                  <div class="tab-content">
                    <crm-report-list
                      [ticketId]="ticket.id"
                      [isDetailPage]="preview"
                      [withProposal]="true"
                      [reportType]="reportType"
                      [reports$]="reports$"
                      [ticket$]="ticket$"
                    ></crm-report-list>
                  </div>
                </mat-tab>
              }
            </ng-container>
            <!-- Working periods and travels (mobile only) -->
            <ng-container>
              <mat-tab aria-labelledby="hidden-md-lg">
                <ng-template mat-tab-label
                  >{{ 'workLog' | i18nextCap }}
                </ng-template>
                <div class="tab-content">
                  @if (ticket) {
                    <crm-working-hours-registry
                      [isDetailPage]="preview"
                      [usersAssignees$]="assignees$"
                      [ticket$]="ticket$"
                    ></crm-working-hours-registry>
                  }
                </div>
              </mat-tab>
            </ng-container>
            <ng-container>
              <mat-tab aria-labelledby="hidden-md-lg">
                <ng-template mat-tab-label
                  >{{ 'history' | i18nextCap }}
                </ng-template>
                <div class="tab-content">
                  <crm-history [history]="history$ | async" />
                </div>
              </mat-tab>
            </ng-container>
          </mat-tab-group>
        </div>
        <!-- Right -->
        <div class="right-col col-md-4 hidden-sm hidden-xs">
          <div class="d-flex flex-column right-column-gap overflow-auto">
            <mat-accordion>
              <crm-expansion-panel title="{{ 'forms:details' | i18nextCap }}">
                <crm-form-template
                  [formGroup]="detailsFormGroup"
                  [formFields]="formDetailsFields"
                ></crm-form-template>
                <fo-work-order-scheduling-issues [overlaps]="overlaps">
                </fo-work-order-scheduling-issues>
                <crm-form-template
                  [formGroup]="additionalInfoGroup"
                  [formFields]="additionalFormFields"
                ></crm-form-template>
              </crm-expansion-panel>
              <crm-expansion-panel
                title="{{ 'forms:workingRegistry' | i18nextCap }}"
              >
                @if (ticket) {
                  <crm-working-hours-registry
                    [isDetailPage]="preview"
                    [usersAssignees$]="assignees$"
                    [ticket$]="ticket$"
                  ></crm-working-hours-registry>
                }
              </crm-expansion-panel>
              <crm-history [history]="history$ | async" />
            </mat-accordion>
          </div>
        </div>
      </div>
    </form>
  }
</crm-container>
<footer class="hidden-lg hidden-md">
  <mat-toolbar class="toolbarNav">
    <button
      mat-flat-button
      (click)="updateSelectedTab(0)"
      [ngClass]="{ active: selected == 0 }"
    >
      <fa-icon [icon]="faList" size="lg" class="icon-color"></fa-icon>
      <span class="label">{{ 'forms:details' | i18nextCap }}</span>
    </button>
    <button
      mat-flat-button
      (click)="updateSelectedTab(4)"
      [ngClass]="{ active: selected == 4 }"
    >
      <fa-icon [icon]="faClock" size="lg" class="icon-color"></fa-icon>
      <span class="label">{{ 'translation:workLog' | i18nextCap }}</span>
    </button>
    <button
      mat-flat-button
      (click)="updateSelectedTab(1)"
      [ngClass]="{ active: selected == 1 }"
    >
      <fa-icon [icon]="faGear" size="lg" class="icon-color"></fa-icon>
      <span class="label">{{ 'translation:actions' | i18nextCap }}</span>
    </button>
    <button
      mat-flat-button
      (click)="updateSelectedTab(3)"
      [ngClass]="{ active: selected == 3 }"
    >
      <fa-icon [icon]="faChartLine" size="lg" class="icon-color"></fa-icon>
      <span class="label">{{ 'forms:reports' | i18nextCap }}</span>
    </button>
    <button
      mat-flat-button
      (click)="openBottomSheet()"
      [ngClass]="{
        active:
          selected == WorkOrderTabsIndex.HISTORY ||
          selected == WorkOrderTabsIndex.REQUESTS,
      }"
    >
      <fa-icon [icon]="faEllipsis" size="lg" class="icon-color"></fa-icon>
      <span class="label">{{ 'translation:more' | i18nextCap }}</span>
    </button>
  </mat-toolbar>
</footer>
<ng-template #plannedDateInput>
  <fo-date-time-range-input
    [formControl]="detailsFormGroup.controls.plannedDate"
    [minTimeMinutes]="schedulingConfig.startWorkingMinute"
    [maxTimeMinutes]="schedulingConfig.endWorkingMinute"
  />
</ng-template>
<ng-template #blockingMotiveInput>
  @let ticket = ticket$ | async;
  @let motives = motives$ | async;
  @if (
    ticket.status.name === 'Blocked' &&
    (motives?.length > 0 || ticket.blockingMotive != null)
  ) {
    <form [formGroup]="motiveForm" class="motive-form">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'blockingMotive' | i18nextCap }}</mat-label>
        <fo-autocompleting-select
          formControlName="motive"
          [choices]="motives$"
        />
        <fo-arrow matSuffix />
      </mat-form-field>
      @if (motiveSelected$ | async) {
        <mat-form-field appearance="outline">
          <mat-label>{{ 'blockingMotiveNotes' | i18nextCap }}</mat-label>
          <textarea matInput formControlName="notes"></textarea>
        </mat-form-field>
      }
    </form>
  }
</ng-template>
<ng-template #contactIdInput>
  <div class="contact-id-field">
    <crm-form-select
      class="contact-id-select"
      [formGroup]="infoTabFormGroup"
      [field]="contactIdField"
      [multiple]="true"
    ></crm-form-select>
    @if (canEditContacts$ | async) {
      <fo-plus-button (click)="onClickAddContact()"></fo-plus-button>
    }
  </div>
</ng-template>
<mat-menu #companyGeolocationMenuRef>
  @for (option of companyGeolocationOptions$ | async; track $index) {
    <button
      mat-menu-item
      (click)="openUrlInNewTab(option.url)"
      class="more-options-menu-item"
    >
      {{ option.providerName }}
    </button>
  }
</mat-menu>
